'use strict';

var cart = require('../cart/cart');

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    // While a dialog is attached the minicart exposes role="button", so it has to answer Space
    // the way a real button does - an anchor only activates on Enter (WCAG 4.1.2 / 2.1.1).
    $('body').on('keydown', '.js-minicart-link[role="button"]', function (event) {
        if (event.key === 'Space' || event.key === ' ') {
            event.preventDefault();
            $(this).trigger('click');
        }
    });

    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
};
